import { useState, type FormEvent } from 'react';
import { navigate, useLocation } from '@reach/router';
import { useTranslation } from 'react-i18next';
import useModal from '@/components/Modal/hooks/useModal';
import Modal from '@/components/Modal/Modal';
import SearchIcon from '../../icons/SearchIcon';
import { SEARCH_PATHNAME, SEARCH_TITLE } from '../../utils/constants';
import { getPathWithLanguage, getLanguageFromPath } from '@/utils/localization';
import {
  Wrapper,
  Form,
  Label,
  InputWrapper,
  Input,
  IconWrapper,
  Button,
} from './SearchModal.styles';

const SearchBar = ({ modalID }: { modalID: string }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const currentLanguage = getLanguageFromPath(pathname);
  const { close } = useModal();
  const [value, setValue] = useState('');
  const closeModal = () => close(modalID);
  const onChangeInput = (event: FormEvent<HTMLInputElement>) => setValue(event.currentTarget.value);

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const queryString = new URLSearchParams();
    queryString.append('query', value);
    navigate(getPathWithLanguage(`${SEARCH_PATHNAME}?${queryString}`, currentLanguage));
    closeModal();
    return false;
  };

  return (
    <Modal
      modalElements={{
        rich_text: { value: '', images: [], links: [], modular_content: [] },
        title: { value: SEARCH_TITLE },
        url_slug: { value: modalID },
      }}
    >
      <Wrapper>
        <Form onSubmit={onFormSubmit}>
          <div>
            <Label htmlFor="search">{t('search.Search sonarsource.com')}</Label>
            <InputWrapper>
              <Input
                type="text"
                name="query"
                id="query"
                value={value}
                onChange={onChangeInput}
                placeholder={t('search.What are you looking for today')}
                autoFocus
              />
              <IconWrapper>
                <SearchIcon />
              </IconWrapper>
            </InputWrapper>
          </div>
          <Button aria-label="Search">{t('search.Submit')}</Button>
        </Form>
      </Wrapper>
    </Modal>
  );
};

export default SearchBar;
